'use strict';

export const loginFieldElements = () => ({
    closeButton: document.querySelectorAll('div#login-form a.close'),
    formContainer: document.querySelector('div#login-form div.form-container'),
    loggedInContainer: document.querySelector('div#login-form div.logged-in-container'),
    loginForm: document.querySelector('div#login-form form'),
    loginButton: document.querySelector('div#login-form button#login-button'),
    inputLoginName: document.querySelector('div#login-form input#loginName'),
    inputPassword: document.querySelector('div#login-form input#password')
});
